// Dependencies
import React from 'react'

// Styles
import { LoadingStyle, LoadingStyleBlack } from './styles'

// Types
type Props = {
  className?: string
  color?: 'white' | 'black'
}

// interface Props extends HTMLAttributes<HTMLDivElement> {}
export const Loading = ({ className, color = 'white' }: Props) => {
  const Style = color === 'white' ? LoadingStyle : LoadingStyleBlack

  return (
    <Style className={className}>
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </Style>
  )
}
